import cns from 'classnames';
import { useKeenSlider } from 'keen-slider/react';
import { useStoreBannerList } from '../../../../services';
import S from './AppBanner.module.scss';
const AppBanner = () => {
  const bannerList = useStoreBannerList();
  const [sliderRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    loop: true
  }, [
  // add plugins here
  slider => {
    let timeout: ReturnType<typeof setTimeout>;
    let mouseOver = false;
    function clearNextTimeout() {
      clearTimeout(timeout);
    }
    function nextTimeout() {
      clearTimeout(timeout);
      if (mouseOver) return;
      timeout = setTimeout(() => {
        if (bannerList.data?.length ?? 0 > 1) {
          slider.next();
        }
      }, 5000);
    }
    slider.on('created', () => {
      slider.container.addEventListener('mouseover', () => {
        mouseOver = true;
        clearNextTimeout();
      });
      slider.container.addEventListener('mouseout', () => {
        mouseOver = false;
        nextTimeout();
      });
      nextTimeout();
    });
    slider.on('dragStarted', clearNextTimeout);
    slider.on('animationEnded', nextTimeout);
    slider.on('updated', nextTimeout);
  }]);
  const onClickBanner = (link?: string) => {
    if (link) {
      window.open(link);
    }
  };
  return <div className={S.app_banner_wrapper} data-sentry-component="AppBanner" data-sentry-source-file="AppBanner.tsx">
      <div ref={sliderRef} className={cns('keen-slider', S.slider_div)}>
        {bannerList.data?.map((banner, index) => <div key={index} className={cns('keen-slider__slide', S.banner_wrapper)}>
            <div key={index} className={S.banner_item} style={{
          background: banner.background,
          cursor: banner.link ? 'pointer' : undefined
        }} onClick={() => onClickBanner(banner.link)}>
              <div className={S.text_wrapper}>
                <h2 className={S.banner_title}>{banner.title}</h2>
                <p className={S.banner_subtitle}>{banner.subtitle}</p>
              </div>
              <img className={S.banner_image} src={banner.image} alt={banner.title} />
            </div>
          </div>)}
      </div>
    </div>;
};
export default AppBanner;